import axios from "axios";

const createTechnicianPlans = async (plan) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/technicianplans`, plan)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};
const getAllDataTechnicianPlans = async () => {
  // const params = { open: open }; // Constructing the query parameter
  return axios
    .get(`${process.env.REACT_APP_API_URL}/technicianplans`)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};
// const getAllTechnicianPlans = async () => {
//   return axios
//     .get(`${process.env.REACT_APP_API_URL}/TechnicianPlans`)
//     .then((response) => {
//       return response.data;
//     })
//     .catch((err) => {
//       throw err.response?.data || err;
//     });
// };

const getAllTechnicianPlans = async (open = false) => {
  const params = { open: open }; // Constructing the query parameter
  return axios
    .get(`${process.env.REACT_APP_API_URL}/TechnicianPlans`, { params })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getAllTechnicianPlansStatus = async (plan_status = "") => {
  const params = { plan_status: plan_status }; // Constructing the query parameter
  return axios
    .get(`${process.env.REACT_APP_API_URL}/TechnicianPlans`, { params })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getTechnicianPlans = async (id) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/TechnicianPlans/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const editTechnicianPlans = async (id, plan) => {
  return axios
    .patch(`${process.env.REACT_APP_API_URL}/TechnicianPlans/${id}`, plan)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const deleteTechnicianPlans = async (id, force) => {
  return axios
    .delete(
      `${process.env.REACT_APP_API_URL}/technicianplans/${id}?force=${force}`
    )
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getTechnicianPlansFindJobs = async (params) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/technicianplans/find-job${params || ""}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getTechnicianPlanning = async (params) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/technicianplans/planning-inform${params || ""}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getTechnicianPlanningCalendar = async (params) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/technicianplans/tech-work-calendar${params || ""}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};


const TechnicianPlansService = {
  createTechnicianPlans,
  getAllTechnicianPlans,
  getAllTechnicianPlansStatus,
  getTechnicianPlans,
  editTechnicianPlans,
  deleteTechnicianPlans,
  getAllDataTechnicianPlans,
  getTechnicianPlansFindJobs,
  getTechnicianPlanning,
  getTechnicianPlanningCalendar
};

export default TechnicianPlansService;
